type CurrentBoardIdAction =
  | { type: "PUT_BOARD_ID_IN_REDUX"; payload: { boardId: string } }
  | { type: "ADD_BOARD"; payload: { boardId: string; boardTitle: string; userId: string } };

type CurrentBoardIdState = string | null;

const currentBoardId = (state: CurrentBoardIdState = null, action: CurrentBoardIdAction): CurrentBoardIdState => {
  switch (action.type) {
    case "PUT_BOARD_ID_IN_REDUX":
    case "ADD_BOARD": {
      return action.payload.boardId;
    }
    default:
      return state;
  }
};

export default currentBoardId;
